import { tempoApi } from '@/common/api/tempoApi';
import type { CustomField } from '@/common/api/types/customField';

export interface UpdateItemTypeFieldsRequest {
  fieldIds: number[];
}

const getFieldsForItemType = async (
  itemTypeId: number,
  { includeArchived = false }: { includeArchived?: boolean } = {},
): Promise<CustomField[]> =>
  await tempoApi()
    .get(`api/v1/item-store/item-types/${itemTypeId}/fields`, {
      searchParams: includeArchived ? { includeArchived: true } : {},
    })
    .json<CustomField[]>();

const replaceFieldsForItemType = async (
  itemTypeId: number,
  data: UpdateItemTypeFieldsRequest,
): Promise<CustomField[]> =>
  await tempoApi()
    .put(`api/v1/item-store/item-types/${itemTypeId}/fields`, { json: data })
    .json<CustomField[]>();

export const ItemTypeFieldsApi = {
  getFieldsForItemType,
  replaceFieldsForItemType,
} as const;
